/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Returnairflow2Inputs */



/**
* | output |
* | --- |
* | "Exhaust airflow" |
*
* @param {Ahu_History_Key_Returnairflow2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_returnairflow2 = /** @type {((inputs?: Ahu_History_Key_Returnairflow2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Returnairflow2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Exhaust airflow")
	return /** @type {LocalizedString} */ ("Débit air rejeté")
});
export { ahu_history_key_returnairflow2 as "ahu_history_key_returnAirFlow" }